

import api from "./api";

/**
 * Pin a message to a channel
 * Sends userId in body as fallback if middleware doesn't extract it
 */
export function pinMessage(messageId, channelId, userId) {
  return api.post(`/messages/${messageId}/pin`, {
    channelId,
    userId, // fallback if req.userId isn't set by middleware
  });
}

/**
 * Unpin a message from a channel
 */
export function unpinMessage(messageId, channelId, userId) {
  return api.post(`/messages/${messageId}/unpin`, {
    channelId,
    userId,
  });
}

/**
 * Get all pinned messages for a channel
 */
export function getPinnedMessages(channelId) {

  return api.get(`/channels/${channelId}/pinned-messages`);
}

/**
 * Check if a specific message is pinned
 */
export const isMessagePinned = (message, pinnedMessages = []) => {
  if (!pinnedMessages.length) return false;
  const id = message._id || message.id;
  return pinnedMessages.some(
    (pinned) =>
      (pinned._id || pinned.id) === id ||
      pinned.messageId === id
  );
};

/**
 * Format a pinned message for display
 */
export const formatPinnedMessage = (message) => {
  const content = message.text || message.message || message.content || "";
  const sender =
    message.senderName ||
    message.sender?.name ||
    message.sender?.displayName ||
    message.sender?.username ||
    "Unknown";
  const timestamp = message.timestamp || message.createdAt;

  return {
    id: message._id || message.id,
    content: content.length > 100 ? content.substring(0, 100) + "..." : content,
    sender,
    timestamp: new Date(timestamp).toLocaleString(),
    fullMessage: message,
  };
};